class ReviewMode {
  constructor(section) {
    this.section = section;
    this.trigger = section.querySelector('[data-review-mode-trigger]');
    this.closeButton = section.querySelector('[data-review-mode-close]');
    this.overlay = section.querySelector('.review-mode__overlay');
    this.iframeContainer = section.querySelector('[data-review-mode-iframe-container]');
    this.iframeLoaded = false;

    if (this.trigger) {
      this.init();
    }
  }

  init() {
    this.trigger.addEventListener('click', () => this.handleOpen());
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.handleClose());
    }
  }

  handleOpen() {
    this.overlay.classList.add('is-fading');

    setTimeout(() => {
      this.overlay.style.display = 'none';
      this.loadIframe();
    }, 500);
  }

  handleClose() {
    this.iframeContainer.classList.remove('is-active');

    setTimeout(() => {
      this.overlay.style.display = '';
      this.overlay.classList.remove('is-fading');
    }, 500);
  }

  loadIframe() {
    if (!this.iframeLoaded) {
      const iframe = document.createElement('iframe');
      iframe.src = 'https://extractart.eu/VRtours/INNAN/';
      iframe.frameBorder = '0';
      iframe.width = '100%';
      iframe.height = '100%';
      iframe.scrolling = 'yes';
      iframe.allowFullscreen = true;
      iframe.setAttribute('webkitallowfullscreen', 'true');
      iframe.setAttribute('mozallowfullscreen', 'true');
      iframe.setAttribute('oallowfullscreen', 'true');
      iframe.setAttribute('msallowfullscreen', 'true');

      this.iframeContainer.appendChild(iframe);
      this.iframeLoaded = true;
    }

    this.iframeContainer.classList.add('is-active');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-review-mode]');
  sections.forEach((section) => new ReviewMode(section));
});

if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-review-mode]');
    if (section) {
      new ReviewMode(section);
    }
  });
}
